import {Space} from "antd";
import {CustomPagination} from "../../../../pagination";
import {useGetCustomerUpcomingCallsContext} from "../../../../../context/upcoming-calls/customer";
import {CustomerUpcomingCallCard} from "../../call-card/customer/new";

const CustomerCallsSection = () => {
  const {
    state: {
      customerUpcomingCallsData: {session},
      customerUpcomingCallsApiMetaResponse,
      isPreviousCustomerUpcomingCallsData,
      page,
      setPage,
    },
  } = useGetCustomerUpcomingCallsContext();
  return (
    <div>
      <Space direction="vertical" size={42} style={{display: "flex"}}>
        {session.map((call) => (
          <CustomerUpcomingCallCard key={call.id} session={call} />
        ))}
      </Space>
      <CustomPagination
        isPreviousData={isPreviousCustomerUpcomingCallsData}
        page={page}
        paginationMeta={customerUpcomingCallsApiMetaResponse}
        setPage={setPage}
      />
    </div>
  );
};

export {CustomerCallsSection};
